import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconWarningFill';
/** Renders an SVG icon. */
const SvgWarningFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M26.017 28H5.983c-1.843 0-3.053-1.927-2.251-3.587l10.017-20.75c.91-1.884 3.593-1.884 4.502 0l10.017 20.75c.802 1.66-.408 3.587-2.25 3.587ZM17.5 13a1.5 1.5 0 0 0-3 0v6a1.5 1.5 0 1 0 3 0zM16 25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      />
    </svg>
  );
};
SvgWarningFill.displayName = displayName;
export default SvgWarningFill;
